import * as yup from 'yup';

export const StockHoldingGainLossForm = (t: (key: string) => string) =>
  yup.object().shape({
    venueId: yup.string().required(t('stock.holding.required')),
    searchTerm: yup.string(),
    type: yup.array().of(yup.string()),
    isByDate: yup.boolean(),
    dateTo: yup.string().when('isByDate', {
      is: true,
      then: yup.string().required(t('stock.holding.required-date')),
    }),
  });
